import apiClient from '@u/apiClient'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

import attachmentCategoryAction from './attachmentCategory/actions'
import GetListItemsController from '@/wayfinder/actions/App/Http/Controllers/ListItem/GetListItemsController'
import CreateListItemController from '@/wayfinder/actions/App/Http/Controllers/ListItem/CreateListItemController'
import UpdateListItemController from '@/wayfinder/actions/App/Http/Controllers/ListItem/UpdateListItemController'
import DeleteListItemController from '@/wayfinder/actions/App/Http/Controllers/ListItem/DeleteListItemController'
import ReorderListItemsController from '@/wayfinder/actions/App/Http/Controllers/ListItem/ReorderListItemsController'

export default {
  ...attachmentCategoryAction,

  // region fetch
  fetchListItems({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetListItemsController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeListItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateListItemController.post(), payload.list_item)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateListItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateListItemController.put({ list_item: payload.id }),
          payload.list_item
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region reorder
  reorderListItems(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ReorderListItemsController.put(), {
          group: payload.group,
          list_items: payload.list_items
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deleteListItemById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteListItemController.delete.delete({
            list_item: payload.list_item
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undodelete
  undoDeleteListItemById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/list-item/${payload.id}/undo-delete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
